const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};



class ClickBlocker {
    constructor(blockDate, startHour, startMinute, blockHours, blockMinutes, selector) {
        this.blockDate = blockDate;
        this.startHour = startHour;
        this.startMinute = startMinute;
        this.blockHours = blockHours;
        this.blockMinutes = blockMinutes;
        this.selector = selector;
        this.flag = "";

        this.isBlocked = false;

        this.init();
    }

    get startTime() {
        return this.startHour * 60 + this.startMinute;
    }

    get endTime() {
        return this.startTime + (this.blockHours * 60 + this.blockMinutes);
    }

    init() {
        this.checkBlock();
        this.interval = setInterval(() => this.checkBlock(), 60_000); // every 1 min
    }

    checkBlock() {
        const now = new Date();
        const currentDate = now.getDate();
        const currentTime = now.getHours() * 60 + now.getMinutes();

        const withinDate = currentDate === this.blockDate;
        const withinTime = currentTime >= this.startTime && currentTime < this.endTime;

        if (withinDate && withinTime) {
            this.enableBlocking();
        } else {
            this.disableBlocking();
        }
    }

    enableBlocking() {
        if (!this.isBlocked) {
            document.addEventListener("click", this.blockClick, true);
            this.isBlocked = true;
            this.flag = "ac"
            //console.log("Click blocking ACTIVE");
        }
    }

    disableBlocking() {
        if (this.isBlocked) {
            document.removeEventListener("click", this.blockClick, true);
            this.isBlocked = false;
           // console.log("Click blocking DEACTIVATED");

             this.flag = "dc"
        }
    }

    blockClick = e => {
        if (e.target.closest(this.selector)) {
            e.preventDefault();
            e.stopPropagation();
            console.log(`Click prevented on: ${this.selector}`);
        }
    };
}

const blocker = new ClickBlocker(
    12,              
    12,              
    30,              
    4,               
    15,              
    ".plan-button" 
);